// :cow: Cosmose CONFIDENTIAL :iso:
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'coa-percentage-change',
  templateUrl: './percentage-change.component.html',
  styleUrls: ['./percentage-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PercentageChangeComponent implements OnChanges {
  @Input() value: number;
  isNegative: boolean;
  isPositive: boolean;
  isValueSet: boolean;

  ngOnChanges(): void {
    this.isPositive = this.value > 0;
    this.isNegative = this.value < 0;
  }
}
